import React from "react";
import { Card, Typography, Tag, Divider } from "antd";
import { TeamOutlined, DeleteOutlined, EyeFilled, EditFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { formatToIST } from "../../../helper/CommonHelper";

const { Title, Text } = Typography;

const UserGroupCard = ({ data, onDelete }) => {
  const navigate = useNavigate();

  return (
    <Card
      style={{
        borderRadius: 16,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
      }}
      bodyStyle={{ padding: 16 }}
    >
      {/* Top */}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", gap: 12 }}>
          <div
            style={{
              background: "#f3e8ff",
              padding: 10,
              borderRadius: 10,
            }}
          >
            <TeamOutlined style={{ fontSize: 22, color: "#7c3aed" }} />
          </div>

          <div>
            <Title level={5} style={{ margin: 0 }}>
              {data?.name}
            </Title>
            {/* <Text type="secondary">
              {data?.description || "No description"}
            </Text> */}
          </div>
        </div>

        <Tag style={{ height: "20px", borderRadius: "8px", background: "#f0f0f0" }}>
          {data?.user_count} members
        </Tag>
      </div>

      <Divider />

      {/* Bottom */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Text type="secondary">
          {formatToIST(data?.created_at)}
        </Text>

        <div style={{ display: "flex", gap: 12 }}>
          <EditFilled style={{ color: "#8c3add", cursor: "pointer" }} onClick={() => navigate("/assign-user/" + btoa(data.id))} />

          <EyeFilled style={{ color: "#1890ff", cursor: "pointer", fontSize: "16px" }}
            onClick={() =>
              navigate("/view-group/" + btoa(data.id), {
                state: {
                  groupName: data.name,
                },
              })
            } />

          <DeleteOutlined
            style={{ color: "red", cursor: "pointer" }}
            onClick={() => onDelete(data.id)}
          />
        </div>
      </div>
    </Card>
  );
};

export default UserGroupCard;